var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuSandwich(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 4.44772 0.447715 4 1 4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H1C0.447716 6 0 5.55228 0 5Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 8.44772 0.447715 8 1 8H17C17.5523 8 18 8.44772 18 9C18 9.55228 17.5523 10 17 10H1C0.447716 10 0 9.55228 0 9Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 12.4477 0.447715 12 1 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H1C0.447716 14 0 13.5523 0 13Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuSandwich);
export default __webpack_public_path__ + "static/media/ic_menu_sandwich.7aa6e31f8db64893fd93b4f46c5e8691.svg";
export { ForwardRef as ReactComponent };